import React, { useEffect, useState } from "react";
import Badge from "../atoms/Badge";
import CertifiedBadge from "../shared/CertifiedBadge";

interface RecipeDescriptionProps {
  title: string;
  description: string;
}

const RecipeDescription: React.FC<RecipeDescriptionProps> = (props) => {
  const showReadMore: boolean = props.description.length > 160 ? true : false;
  const desc = showReadMore
    ? `${props.description.slice(0, 160)}... `
    : props.description;

  const [showFullContent, setShowFullContent] = useState<boolean>(false);
  useEffect(() => {
    setShowFullContent(!showReadMore);
  }, [showReadMore]);

  const toggleFullContent = () => {
    setShowFullContent(!showFullContent);
  };

  return (
    <section className="item-desc-section">
      <div className="title-block">
        <h1>{props.title}</h1>
        <CertifiedBadge label="certified" />
      </div>
      <div className="tags-badge-wrap">
        <Badge label="Vegetarian" />
        <Badge label="BIO" />
        <Badge label="Local" />
      </div>
      <div className="read-more-block">
        <p className="read-more-text">
          <>
            <span>{showFullContent ? props.description : desc}</span>
            {(showReadMore || showFullContent) && (
              <span
                className="read-more-toggle"
                onClick={toggleFullContent}
                style={{ cursor: "pointer" }}
              >
                {showFullContent
                  ? " Show less"
                  : showReadMore
                  ? "Read more"
                  : ""}
              </span>
            )}
          </>
        </p>
      </div>
    </section>
  );
};

export default RecipeDescription;
